import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row, Skeleton } from 'antd'

import getRecurringExpenseReviewHistory from 'core/application/expenses/getRecurringExpenseReviewHistory'

import useQueryRequest from 'common/hooks/useQueryRequest'

import Card from '../../../common/components/dataDisplay/Card'
import Collapse from '../../../common/components/dataDisplay/Collapse'
import CollapseItem from '../../../common/components/dataDisplay/CollapseItem'
import NoData from '../../../common/components/feedback/NoData'
import { formatDateTimeAMPM } from '../../../common/dateFormatters'

type PremiumReviewHistoryProps = {
  recurringExpenseId: string
}
const PremiumReviewHistory: React.FC<PremiumReviewHistoryProps> = (props) => {
  const { t: translate } = useTranslation()

  const [reviewHistoryItems, isReviewHistoryItemsLoading, sendGetReviewHistoryItems] = useQueryRequest(null)

  useEffect(() => {
    ;(async () => {
      if (props.recurringExpenseId) {
        await sendGetReviewHistoryItems(() => getRecurringExpenseReviewHistory(props.recurringExpenseId))
      }
    })()
  }, [props.recurringExpenseId])

  return (
    <Skeleton loading={isReviewHistoryItemsLoading}>
      {reviewHistoryItems && reviewHistoryItems.length > 0 && (
        <Card title={translate('doc-review-dashboard.expenses.history-details.title')}>
          <Collapse defaultActiveKey="0">
            {reviewHistoryItems &&
              reviewHistoryItems.length > 0 &&
              reviewHistoryItems.map((item, index) => (
                <CollapseItem
                  key={index}
                  content={
                    <Row>
                      <Col span={12}>
                        <ReviewHistoryItem
                          title={translate('doc-review-dashboard.expenses.history-details.message-to-employee')}
                          content={item.messageToEmployee}
                          className="pr-24"
                        />
                      </Col>

                      <Col span={12}>
                        <ReviewHistoryItem
                          title={translate('doc-review-dashboard.expenses.history-details.internal-notes')}
                          content={item.internalNotes}
                        />
                      </Col>
                    </Row>
                  }
                  header={translate('doc-review-dashboard.expenses.history-details.history-item-title')
                    .replace('[firstName]', item.reviewedBy)
                    .replace('[date]', formatDateTimeAMPM(item.reviewedOn))}
                ></CollapseItem>
              ))}
          </Collapse>
        </Card>
      )}
    </Skeleton>
  )
}

export default PremiumReviewHistory

type ReviewHistoryItemProps = {
  title: string
  content: string
  className?: string
}

const ReviewHistoryItem: React.FC<ReviewHistoryItemProps> = ({ title, content, className }) => {
  return (
    <div className={className}>
      <div>
        <p className="color-gray-8"> {title}</p>
      </div>
      <div className="review_history_item" dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  )
}
